import React from "react";
import { Ban, Crown, KeyRound, ShieldAlert, Unplug } from "lucide-react";

export const GAP_LABEL = { entra_p1: "Entra ID P1", entra_p2: "Entra ID P2", intune_p1: "Intune Plan 1" };
const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" }) : "—");

export default function DrillUserRow({ user: u, signInAvailable }) {
  const roles = u.admin_roles || [];
  const missing = u.gap_missing || [];
  const policies = [...new Set((u.gaps || []).map((g) => g.policy))];
  return (
    <tr data-testid="drill-user-row">
      <td>
        <div className="sku-name">
          {u.display_name}
          {u.guest && <span className="mini-chip">guest</span>}
          {!u.enabled && (
            <span className="mini-chip warn">
              <Ban size={10} /> disabled
            </span>
          )}
        </div>
        <div className="sku-part mono">{u.upn}</div>
        {u.department && <div className="drill-sub">{u.department}</div>}
      </td>
      <td>
        <div className="lic-chips">
          {u.licenses.length === 0 && <span className="muted">none</span>}
          {u.licenses.map((l) => (
            <span key={l} className="mini-chip">
              {l}
            </span>
          ))}
        </div>
      </td>
      <td>
        {missing.length === 0 && <span className="muted">—</span>}
        <div className="lic-chips">
          {missing.map((m) => (
            <span key={m} className="mini-chip warn" data-testid={`drill-missing-${m}`}>
              <ShieldAlert size={10} /> {GAP_LABEL[m] || m}
            </span>
          ))}
        </div>
        {policies.length > 0 && <div className="drill-sub">{policies.join(" · ")}</div>}
      </td>
      <td>
        <div className="lic-chips">
          {u.mfa_registered === false && u.enabled && !u.guest && (
            <span className="mini-chip crit" data-testid="drill-nomfa">
              <KeyRound size={10} /> no MFA
            </span>
          )}
          {u.mfa_registered === true && (
            <span className="mini-chip ok">
              <KeyRound size={10} /> MFA
            </span>
          )}
          {roles.map((r) => (
            <span key={r} className={`mini-chip ${r === "Global Administrator" ? "warn" : ""}`} data-testid="drill-role">
              <Crown size={10} /> {r.replace(" Administrator", " admin")}
            </span>
          ))}
          {roles.length > 0 && <span className={`mini-chip ${u.entra === "p2" ? "ok" : "warn"}`}>{u.entra === "p2" ? "Entra P2" : u.entra === "p1" ? "Entra P1 only" : "no Entra P1/P2"}</span>}
          {u.legacy_signins > 0 && (
            <span className="mini-chip warn" title={(u.legacy_apps || []).join(", ")} data-testid="drill-legacy">
              <Unplug size={10} /> {u.legacy_signins} legacy sign-in{u.legacy_signins === 1 ? "" : "s"}
            </span>
          )}
        </div>
        {u.legacy_signins > 0 && <div className="drill-sub">{(u.legacy_apps || []).join(", ")}</div>}
      </td>
      <td className={`muted small ${u.inactive && u.licenses.length ? "warn" : ""}`}>{signInAvailable ? fmtDate(u.last_sign_in) : "n/a"}</td>
    </tr>
  );
}
